export default {
  message: {
    loginTitle: 'GRAND EVENTS',
    loginDesc:'Online Service System',
    // loginWays:['PC Login','WeChat Login'],
    loginWays:['PC Login'],
    loginUser:'Please fill in your cell phone number or Email',
    registerUser:'Please fill in your cell phone number',
    loginPass:'Please fill in your password',
    loginBtn:'Login',
    loginManual:'Instruction Manual',
    loginAbout:'About us',
    forgetPass:'Forget password',
    register:'Register',
    enterCode:'Enter Code',
    getCode:'Get code via SMS',
    getCodeAgain:'Resend（60S）',
    fillCompanyName:'Please fill in a full company name ',
    registerBtn:'Register',
    login:'Login',
    createPass:'Please fill in the new login password',
    surePass:'Please confirm the new login password',
    changePass:'Reset Password',
    scan:'Scan QR Code with WeChat',
    // 展会列表
    enterExhibition:'Enter the Exhibition',
    timeOver:'EXHIBITION BEGINS IN: ',
    days:'DAYS',
    // 首页
    Unfold:'Unfold',
    Fold:'Fold',
    StatusDrawingReview:'Status of drawing review',
    homePage:'Home Page',
    // currentExhibition:'Current Exhibition',
    currentExhibition:'Click to enter exhibition homepage',
    switchExhibition:'Switch Exhibition',
    me:'My Space',
    logout:'Logout',
    addBooth:'Add Booth',
    aboutExhibition:'About the Exhibition',
    relevantDocuments :'Relevant Documents',
    No:'No.',
    documentName:'Document Name',
    documentSize:'Document Size',
    operation:'Operation',
    download:'Download',
    myBooth:'My Booth',
    boothNo:'Booth  No.',
    exhibitorName:"Exhibitor's Name",
    pubdate:'Pubdate',
    boothType:'Booth  Type',
    fasciaBoard:'Fascia Board',
    rental:'Rental',
    upgrades:'Shell Scheme Booth Upgrades',
    depositRefund:'Deposit Refund',
    check:'Check',
    notice:'Notice',
    edit:'Edit',
    drawings:'submission of drawings',
    more:'More',
    // 添加展位
    shellScheme :'Shell Scheme',
    rawSpace:'Raw Space',
    hall:'Hall',
    exhibitionImage:'Basic Stand Type',
    select:'Please Select',
    enter:'Please enter',
    boothArea:'Booth Area',
    openSide:'Number of Open Side',
    contactPerson:'Contact Person',
    contactTel:'Tel.',
    contactEmail:'Email',
    confirm:'Confirm',
    editBooth:'Edit booth',
    addBoothWarn:'Less than 60 bytes',
    doubleLayerArea:'Double layer Area',
    ConstructorName:"Constructor's Name",
    ContactPerson:'Contact Person',
    ConstructorTel:'Tel.',
    ConstructorEmail:'Email',


    // 添加楣板
    cnFasciBoard:'CN Fascia Board',
    enFasciBoard:'EN Fascia Board',
    boothDesignPicture:'Booth Design Picture',
    furnitureConfiguration:'Furniture Configuration',
    upLoadFile:'Upload file',
    hasUpload:'Uploaded',
    fasciBoardWarn:'The picture is only for reference and does not represent actual effects',
    lookFasciBoard:'View the fascia board',
    addFasciBoard:'Add a fascia board',
    // 租赁
    equipmentRental:'Equipment Rental',
    furnitureRental:'Furniture Rental',
    otherService:'Other Service',
    addSchedule:'Add',
    addScheduleDesc:'Please go to Cart for order payment after adding all rental items.',
    cart:'Cart',
    cartTip: 'Please click the "Cart" button to place an order after the purchase is completed.',
    // 定制服务
    shellSchemeUpgrades:"Shell Scheme Upgrades",
    shellSchemePosterDecoration:'Shell Scheme Poster Decoration',
    // 物品详情
    itemSpecific:'Item Specific',
    rentalPeriod:'Rental Period',
    specification:'Specification',
    quantity:'Quantity',
    remark:'Remark',
    deposit:'Deposit',
    item:'Item',
    unitPrice:'Unit Price（RMB）',
    depositRMB:'Deposit（RMB）',
    delete:'Delete',
    selectAll:'Select All',
    total:'Total',
    includingRentalDeposit:'including rental deposit',
    toPay:'To Pay',
    orderConfirmation:'Order Confirmation',
    paymentAmount:'Payment Amount',
    orderConfirmBtn:'Confirm',
    orderConfirmWarn:'Please pay the order through "My Booth" after the order approval. ',
    goToOrder:'The order has been generated. Do you want to check it?',
    viewOrder:'View the order',
    toHome:'Back to the homepage',
    rentalPrice:'Rental price',
    // 个人中心 - 基本信息
    generalInformation:'General Information',
    myBooth :'My Booth ',
    complianceNotices:'Non-Compliance Notices',
    supplementaryInformation:'Supplementary Information',
    account:'Account',
    companyName:'Company Name',
    accountType:'Account Type',
    exhibitor:'Exhibitor',
    businessAddress:'Business Address',
    accountContactPerson:'Contact Person',
    title:'Title',
    email:'Email',
    tel:'Tel.',
    save:'Save',
    exhibitionName:'Exhibition Name',
    paymentReminder:'Payment Reminder',
    totalAmount:'Total Amount ( including deposit )',
    depositReceipt:'Download Deposit Receipt',
    invoice:'Invoice',
    depositRefund:'Deposit Refund',
    buyItem:'Item',
    amount:'Amount',
    orderTime:'Order Time',
    status:'Status',
    viewInvoice:'View Invoice',
    uploadPaymentVoucher:'Upload payment voucher',
    cancelOrder:'Cancel Order',
    paySuccessWarn:'UploadSuccess. Please wait for the confirmation',
    ok:'OK',
    boothSearch:'Search by Exhibition Name, Booth No. - Search',
    unpaidWarn:'Unpaid',
    paidWarn:'None',
    // 违规信息
    violationInformation:'Violation Information',
    fileName:'File Name',
    fileStatus:'File Status',
    uploadTime:'Upload Time',
    upload:'Upload',
    reminder:'Reminder',
    infoUploadSuccess:'UploadSuccess. Please wait for the confirmation-OK',
    cancel:'Cancel',
    // 退押金
    deduction:'Deduction',
    photo:'Photo',
    depositRefundWarn:'Please upload payment voucher. The deposit will be refunded to your account within 30 working days after the confirmation.',
    cancelOrderWarn:"Are you sure you want to cancel the order?-Don't cancel",
    yes:"Yes",
    not:'No',
    // 报图
    uploadFile2:'Upload Files',
    length:'Length',
    width:'Width',
    area:'Area',
    extraHigh:'Extra high',
    haningPoint:'Haning point',
    doubleLayer:'Double layer',
    ceiling:'Ceiling',
    ceilingArea:'Ceiling Area',
    reviewComments:'Review Comments',
    approver:'approver',
    reviewDate:'Review date',
    SingleImageLimited:'Single image limited less than 2M',
    Approved:'Approved',
    Pending:'Pending',
    close:'Close',
    Search:'Search',
    ApplicationRefund:'Application for refund',
    Approval:'Submit for Approval',
    Failed:'Failed',
    Submit:'Submit',
    Upload2:'Upload',
    reUpload:'Re-upload Files',
    pictureUploadWarn:"Please upload at once which up to 10 images(You can hold down the CTRL key to select more). When click on 'Upload' button does nothing, please replace other browser. ( recommend Google chrome) Support jpg,png,bmp,jpeg format files.",
    refundReason:'Please enter the refund reason',
    checkReason :'Check the reason',
    BoothHeight:'Booth Height',
    // 开发票
    invoicedAmount:'Total invoiced amount',
    applicationInvoicedAmount:'Application invoiced amount',
    pickupMethod:'Pickup method',
    receivedScene:'Received at the scene',
    sfFreight:'Mailing after the exhibition(SF freight collect)',
    typeInvoice:'Type of invoice',
    FreeInvoice:'Free text invoice',
    VATInvoice:'VAT invoice',
    InvoiceTitle:'Invoice Title',
    TaxpayerRegistrationNumber:"Taxpayer's Registration Number",
    BankName:'Bank Name',
    BankAccount:'Bank Account',
    RegisteredAddress:'Registered Address',
    Telephone:'Telephone',
    Remarks:'Remarks',
    ApplicationDate:'Application Date',
    RejectReason:'Reject Reason',
    Addressee:'Addressee',
    AddresseeTelephone:'Telephone',
    MailingAddress:'Mailing Address',
    invoiceSubmit:'Submit',
    UploadAttachments:'Upload Attachments',
    InvoiceInformation:'Invoice Information',
    notUploaded:'Not uploaded',
    uploadReminder: 'Reminder：Please upload the payment proof in time（including deposit）. The system will open auditing permission upon confirming the full payment.'
  }
}



// WEBPACK FOOTER //
// ./src/assets/language/language-EN.js